<template>

<b-navbar toggleable="md" variant="light" type="light">
  <b-btn variant="default" class="navbar-toggler" v-b-toggle.sidebarCollapse><span class="navbar-toggler-icon"></span></b-btn>
  <b-navbar-brand :to="{name: 'Landing'}" class="py-0">
    <img src="/static/darkBrandLogo.png" alt="Elecmarba" height="40px">
  </b-navbar-brand>
  <b-navbar-nav>
    <b-nav-item v-if="session.loggedIn" :to="{name: 'WorkOrderIndex'}">1ª Validación</b-nav-item>
    <b-nav-item v-if="hasAuthority('ROLE_ADMINISTRATIVE_VALIDATION')" :to="{name: 'WorkOrderAdminIndex'}">2ª Validación</b-nav-item>
    <b-nav-item v-if="hasAuthority('ROLE_WORK_ORDER_HISTORY')" :to="{name: 'WorkOrderHistory'}">Histórico de Partes</b-nav-item>
    <b-nav-item v-if="hasAuthority('ROLE_USER_SELECT')" :to="{name: 'UserIndex'}">Operarios</b-nav-item>
    <b-nav-item v-if="hasAuthority('ROLE_CLIENT_SELECT')" :to="{name: 'ClientIndex'}">Clientes</b-nav-item>
    <b-nav-item v-if="hasAuthority('ROLE_PROJECT_SELECT')" :to="{name: 'ProjectIndex'}">Proyectos</b-nav-item>
    <b-nav-item v-if="hasAuthority('ROLE_TIME_RECORD')" :to="{name: 'LaborRegistryIndex'}">Registro Laboral</b-nav-item>
  </b-navbar-nav>
  <b-navbar-nav v-show="session.loggedIn" class="ml-auto">
    <b-nav-text class="mr-4">{{session.name}}</b-nav-text>
    <b-button @click="logOut" variant="secondary">Cerrar Sesión</b-button>
  </b-navbar-nav>
</b-navbar>

</template>

<script>

import {session} from '@/auth'

export default {
  name: 'Navbar',
  data() {
    return {
      session
    }
  },
  methods: {
    hasAuthority(authority) {
      return Boolean(session.authorities) && session.authorities.includes(authority)
    },
    logOut() {
      this.$auth.logOut()
      this.$router.push({name: 'Login'})
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue